import { useCountry } from './useCountry'

const adsenseBlockedCountries = new Set([
  'CU', // Cuba
  'IR', // Iran
  'KP', // North Korea
  'RU', // Russia
  'SY', // Syria
])

export function useIsYandexCountry(): boolean | null {
  const country = useCountry()

  return country === null ? null : adsenseBlockedCountries.has(country)
}
